import React, { useEffect, useState } from 'react'
import { graphql, StaticQuery } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image";

const supportedServiceMapping = {
  Nursing: [
    'ltn',
    'https://lp.portea.com/generic-nursing-2021/?utm_source=Pop-Up&utm_medium=organic&utm_campaign=image2LP&utm_content=traffic_organic_popup',
  ],
  'Doctor-consultations': [
    'doctor',
    'https://lp.portea.com/doctor-consultation-popup-nov/?utm_source=Pop-up&utm_medium=organic&utm_campaign=image2LP&utm_content=traffic_organic_popup',
  ],
  'Elder-Care': [
    'ltn',
    'https://lp.portea.com/generic-nursing-2021/?utm_source=Pop-Up&utm_medium=organic&utm_campaign=image2LP&utm_content=traffic_organic_popup',
  ],
  'Trained-attendants': [
    'ltn',
    'https://lp.portea.com/generic-nursing-2021/?utm_source=Pop-Up&utm_medium=organic&utm_campaign=image2LP&utm_content=traffic_organic_popup',
  ],
  Diagnostic: [
    'lab',
    'https://lp.portea.com/diagno-offerings/2023/?utm_source=banner-image&utm_medium=organic&utm_campaign=image2LP&utm_content=traffic_organic_banner2LP',
  ],
  "Labs": [
    'lab',
    'https://lp.portea.com/diagno-offerings/2023/?utm_source=banner-image&utm_medium=organic&utm_campaign=image2LP&utm_content=traffic_organic_banner2LP',
  ],
  "Diabetes-Care": [
    'diabetes',
    'https://lp.portea.com/incontrol-care-plan-kit/?utm_source=Pop-up&utm_medium=organic&utm_campaign=image2LP&utm_content=traffic_organic_popup',
  ],
  "Physiotherapy": [
    'physio',
    'https://lp.portea.com/physiotherapy-300-cb/?utm_source=Pop-up&utm_medium=organic&utm_campaign=image2LP&utm_content=traffic_organic_popup',
  ]
}
function OfferPopupView({ category, data }) {

  const [show, setShow] = useState(false)
  const [popup, setPopup] = useState(null)

  useEffect(() => {
    const mainImg = data[supportedServiceMapping[category] && supportedServiceMapping[category][0]]
    if (mainImg) {
      setPopup(mainImg)
      setTimeout(() => setShow(true), 5000)
    }
  }, [])

  const hideModal = () => setShow(false)

  return (
    <div className={`modal ${show && 'is-active'}`}>
      <div className="modal-background" />
      <div className="modal-content">
        {popup && (
          <a href={supportedServiceMapping[category][1]}>
            <GatsbyImage alt="" image={popup.childImageSharp.gatsbyImageData} />
          </a>
        )}
      </div>
      <button type='button' className="modal-close is-large" onClick={hideModal} />
    </div>
  );
}

const OfferPopup = (props) => (
  <StaticQuery
    query={graphql`query BannerQuery {
  php: file(relativePath: {eq: "banners/php_exitpopup.png"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  lab: file(relativePath: {eq: "banners/Diagnostic_pop_up.png"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  physio: file(relativePath: {eq: "banners/physio_exitpopup.png"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  nursingdiabetes: file(
    relativePath: {eq: "banners/nursing_diabetes_exitpopup.png"}
  ) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  diabetes: file(relativePath: {eq: "banners/diabetes_875.png"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  prime: file(relativePath: {eq: "banners/prime_popup.png"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  doctor: file(relativePath: {eq: "banners/doctor_popup.png"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  ltn: file(relativePath: {eq: "banners/nursing_exitpopup.png"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  hul_oc: file(relativePath: {eq: "banners/hul_oc.jpg"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  covidarmour: file(relativePath: {eq: "banners/covid_armour_popup.png"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
}`}
    render={data => <OfferPopupView data={data} {...props} />}
  />
)

export default OfferPopup
